import { selectAuthenticatedUser, useSelector } from '@missionlabs/api'
import { DestinationTypes } from '@missionlabs/types'
import { useGetDestinationsForUserQuery } from 'shared/store'
import { selectDestinationsByTypes } from 'shared/utils/deviceDestination'

export const useHasUserActiveESim = (): boolean => {
    const user = useSelector(selectAuthenticatedUser)

    // We are interested only in eSim destination types
    const allowedDestinationsTypes = [DestinationTypes.eSim]

    const { destinations = [] } = useGetDestinationsForUserQuery(user?.userID ?? '', {
        skip: !user,
        selectFromResult: result => ({
            ...result,
            destinations: selectDestinationsByTypes(allowedDestinationsTypes)(result)
        })
    })

    return !!destinations.length
}
